module.exports = __webpack_public_path__ + "static/media/19ESCAP22.20d72e40.jpg";